var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.errorComp)?_c(_vm.errorComp,{tag:"component"}):_c('router-view'),_c('Loading'),_c('ServerInfo'),_c('PopupManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }